var modules_6eff0437 = {"card":"AutoSendBanner_module_card__b8d00c0c","timer":"AutoSendBanner_module_timer__b8d00c0c","icon":"AutoSendBanner_module_icon__b8d00c0c","bankInfo":"AutoSendBanner_module_bankInfo__b8d00c0c"};
import "../../../assets/esm/components/Banners/AutoSend/AutoSendBanner~B02Jar_H.css";

export { modules_6eff0437 as default };
//# sourceMappingURL=AutoSendBanner.module.scss.js.map
